const jobRoles = (postType) => (`
    ... on ${postType}_Components_Components_JobRoles {
        fieldGroupName
        title
        numberOfJobs
        settings {
            showComponentTitle
            componentTitle
            spacing
            theme
        }
    }
`);

export default jobRoles;